module.exports = __webpack_public_path__ + "img/minxinwens.1851f5dd.png";